import * as React from "react";
const styles = require("./style.less");

export default class CenteredLayout extends React.Component {
    render() {
        return <div className={styles.container}>{this.props.children}</div>;
    }
}
